import React from "react";
import NumberedHeading from "../components/NumberedHeading";
import SectionBgImg from "../components/SectionBgImg";
import { detailedResultState } from "../../../utils/recoil";
import { useRecoilState } from "recoil";
import { getNodeAssetUrl } from "../../../config";
import { useTranslation } from "react-i18next";

const Books = () => {
  const [data] = useRecoilState(detailedResultState);
  const { t } = useTranslation("result")
  return (
    <div className="py-20 md-max:py-4">
      <NumberedHeading
        number={"7"}
        title={t("books.title")}
        className={"px-[20rem] md-max:px-[1rem]"}
      />
      <div className="my-10 px-[20rem] md-max:px-[1rem] relative">
        <SectionBgImg className={"top-1/2 -translate-y-1/2"} />
        <div className="bg-white shadow-xl z-10 relative rounded-xl p-5 grid grid-cols-1 gap-2">
          {data?.books?.slice(0,5)?.map((item, index) => (
            <div key={index} className="col-span-1 flex md-max:flex-col items-center gap-4">
              <img
                src={getNodeAssetUrl(item?.image, "/book.png")}
                alt="book"
                className="w-44 h-28 object-contain"
              />
              <div className="flex flex-col md-max:items-center md-max:text-center gap-1">
                <p className="text-xl font-semibold">{item?.title}/ {t("by")} <span className="font-normal">{item?.author}</span> </p>
                <p className="text-[#4B5563] w-[70%] md-max:w-[90%]">
                  {item?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Books;
